import React from 'react';
import isEqual from 'lodash/isEqual';

function getOrdinalNumberString(number) {
  const numStr = number.toString();
  const lastDigit = numStr[numStr.length - 1];
  switch (true) {
    case (lastDigit === '1' && number !== 11): return `${number}st`;
    case (lastDigit === '2' && number !== 12): return `${number}nd`;
    case (lastDigit === '3' && number !== 13): return `${number}rd`;
    default: return `${number}th`;
  }
}

function uniqueValuesFilter(value, index, self) {
  return self.indexOf(value) === index;
}

function getOrdinalNumber(number) {
  const numStr = number.toString();
  const lastDigit = numStr[numStr.length - 1];
  switch (true) {
    case (lastDigit === '1' && number !== 11): return <span>{number}<span className="ordinal-abb">st</span></span>;
    case (lastDigit === '2' && number !== 12): return <span>{number}<span className="ordinal-abb">nd</span></span>;
    case (lastDigit === '3' && number !== 13): return <span>{number}<span className="ordinal-abb">rd</span></span>;
    default: return <span>{number}<span className="ordinal-abb">th</span></span>;
  }
}

function roundNumber(number, defaultValue = '-') {
  return number != null && !isNaN(number) ?
    Math.round(+number) : defaultValue;
}

function roundNumberWithDecimals(number, decimals = 2) {
  return !Number.isNaN(number) ?
    Number.parseInt(Number(number).toFixed(decimals), 10) : 'NaN';
}

function trafficColors(rawValue) {
  const value = roundNumber(rawValue);
  if (value < 30) {
    return '#a3282f';
  } else if (value >= 30 && value < 45) {
    return '#f98c42';
  } else if (value >= 45 && value < 60) {
    return '#fff08c';
  } else if (value >= 60 && value < 75) {
    return '#c0ee9f';
  } else if (value >= 75) {
    return '#71e27c';
  }
  return '#2a3844';
}

function trafficColorsClass(valueRaw) {
  const value = roundNumber(+valueRaw);

  if (!value) {
    return '-no-data';
  } else if (value < 30) {
    return '-failing';
  } else if (value >= 30 && value < 45) {
    return '-weak';
  } else if (value >= 45 && value < 60) {
    return '-partial';
  } else if (value >= 60 && value < 75) {
    return '-satisfactory';
  }
  return '-good';
}

function parseCountriesRank(countries) {
  let countriesRank = [];
  let countriesRankNull = [];

  countries.forEach(c => {
    c['country-sectors'].forEach(s => {
      const country = {
        name: `${c.name} (${s.sector.name})`,
        rank: s.rank,
        score: s.score
      };

      s.rank ? countriesRank.push(country) : countriesRankNull.push(country);
    });
  });

  countriesRank = countriesRank.sort((a, b) => a.rank - b.rank);
  countriesRankNull = countriesRankNull.sort((a, b) => a.name - b.name);

  return countriesRank.concat(countriesRankNull);
}

/**
 * Compares if two arrays are equal based on their length and inner content.
 * It also compares array with objects.
 * @param {array} originalArray - the original array.
 * @param {array} comparedArray - the array to be compared with.
 */
function isArrayEqual(originalArray, comparedArray) {
  let isArrEqual = true;

  if (originalArray.length !== comparedArray.length) {
    return !isArrEqual;
  }

  originalArray.forEach((arr, index) => {
    if (isArrEqual && !isEqual(arr, comparedArray[index])) {
      isArrEqual = !isArrEqual;
      return;
    }
  });

  return isArrEqual;
}

// Track download event
function trackDownload(e) {
  const href = e.currentTarget.href;
  const ext = href.replace(/^.*\./, '');
  const type = ext.slice(0, ext.indexOf('?') !== -1 ? ext.indexOf('?') : ext.length);
  const action = e.currentTarget.download ? 'Download' : 'Visit';
  ga('send', 'event', type, action, e.currentTarget.download, 1);
}
function range(size, startAt = 0) {
  return [...Array(size).keys()].map(i => i + startAt);
}
function getLatestYear(year = []) {
  let latestYear = null;
  if (year && Array.isArray(year)) {
    if (year.length === 1) return year[0];
    const sortedYears = year
      .filter((el) => el && !isNaN(el))
      .sort((a, b) => parseFloat(b) - parseFloat(a));
    if (sortedYears.length) {
      latestYear = sortedYears[0];
    }
  }
  return latestYear;
}
function isStringSame(str1, str2) {
  if (!str1 || !str2) return false;
  return String(str1).toLowerCase().includes(String(str2).toLowerCase())
   || String(str2).toLowerCase().includes(String(str1).toLowerCase());
}
function hasNonNullFields(obj, keyPrefix, ignoreKeys = []) {
  const keys = Object.keys(obj).filter(el => el && el.startsWith(keyPrefix) && !ignoreKeys.includes(el));
  let hasValidField = false;
  keys.forEach(el => {
    if (!!obj[el]) { hasValidField = true; }
  });
  return hasValidField;
}


function isValidValue(value) {
  return value !== null && value !== undefined;
}

function isValidNumber(value) {
  if (!isValidValue(value)) return false;
  return !isNaN(Number(value));
}


export {
  getOrdinalNumberString,
  getOrdinalNumber,
  trafficColors,
  trafficColorsClass,
  parseCountriesRank,
  roundNumber,
  isArrayEqual,
  roundNumberWithDecimals,
  trackDownload,
  range,
  getLatestYear,
  isStringSame,
  hasNonNullFields,
  uniqueValuesFilter,
  isValidValue,
  isValidNumber
};



// WEBPACK FOOTER //
// ./app/utils/general.js